/**
 * Shared Redux hooks for the application
 * 
 * These hooks provide typed access to Redux dispatch and selectors.
 * Use these instead of importing directly from react-redux for consistency.
 */

import { useDispatch, useSelector } from 'react-redux';

/**
 * Typed dispatch hook
 * @returns {Function} Redux dispatch function
 */
export const useAppDispatch = () => useDispatch();

/**
 * Typed selector hook
 * @param {Function} selector - Selector function
 * @returns {*} Selected state value
 */
export const useAppSelector = useSelector;

